import React from 'react';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { ChangeLogLabel, ChangeLogTree, DescriptionText } from './changeLog/ChangeLog.styles';
import { getVoyageNumberString } from 'src/utils/stowage/stowageRotationUtils';
import { SequenceChangeType } from 'src/types/ViewModel/Stowage/Rotation/SequenceChangeType';
import theme from 'src/theme';

interface StowagePlanManuallyEditedMessageProps {
    portCalls: RotationPortCall[];
}

const StowagePlanManuallyEditedMessage: React.FC<StowagePlanManuallyEditedMessageProps> = ({ portCalls }) => {
    const MovedText = (hasChangedSequence?: SequenceChangeType) => {
        if (!hasChangedSequence) return <></>;
        return <ChangeLogLabel>Moved</ChangeLogLabel>;
    };

    return (
        <ChangeLogTree>
            <li className="dd-item">
                {portCalls.map((pc) => (
                    <ul key={`manually_changed_${pc.portCallGuid}`} className="tree-port-calls">
                        <ChangeLogLabel> {getVoyageNumberString(pc)}</ChangeLogLabel> - {pc.portDisplayName} {MovedText(pc.hasChangedSequence)}
                        <ul className="tree-berth-calls">
                            {pc.berthCalls.map((bc, index) => (
                                <li key={'manually_changed_berthCall_' + bc.berthCallGuid + '_' + index}>
                                    {bc.berthName} {MovedText(bc.hasChangedSequence)}
                                </li>
                            ))}
                        </ul>
                    </ul>
                ))}
            </li>
            <br />
            <DescriptionText style={{ color: theme.colors.text.warningDark }}>
                If these changes are correct, please update the rotation in IMOS before syncing to avoid data mismatch.
            </DescriptionText>
        </ChangeLogTree>
    );
};

export default StowagePlanManuallyEditedMessage;
